// src/utils/errorReporting.js
// Remonte les erreurs JavaScript du site au serveur, qui prévient l'administratrice par email.
const ENDPOINT = 'https://cyberguard-api-ka8f.onrender.com/api/client-errors';
const MAX_PER_PAGE = 5;
let sent = 0;
const seen = new Set();

export function reportError(error, extra = {}) {
  try {
    if (process.env.NODE_ENV !== 'production' || sent >= MAX_PER_PAGE) return;
    const message = String(error?.message || error || '').slice(0, 300);
    if (!message || seen.has(message)) return;
    seen.add(message);
    sent += 1;
    const body = JSON.stringify({
      message,
      stack: String(error?.stack || extra.componentStack || '').slice(0, 3000),
      page: window.location.origin + window.location.pathname,
      user_agent: navigator.userAgent,
    });
    // Texte brut + keepalive : envoyé même si la page se ferme, sans requête préalable CORS.
    fetch(ENDPOINT, { method: 'POST', body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(() => {});
  } catch {
    /* la remontée d'erreur ne doit jamais en provoquer une autre */
  }
}

export function installErrorReporting() {
  window.addEventListener('error', (e) => reportError(e.error || e.message));
  window.addEventListener('unhandledrejection', (e) => {
    // Les erreurs réseau d'axios (serveur en veille, connexion coupée) sont déjà affichées à l'utilisateur.
    if (e.reason?.isAxiosError) return;
    reportError(e.reason);
  });
}
